module.exports = __webpack_public_path__ + "static/media/jira.f88c5702.png";